import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useContext } from 'react';
import { isValidElementType } from 'react-is';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import { List as List$1, ItemIcon as ItemIcon$1, Item as Item$1, Addon, ItemSecondaryAction as ItemSecondaryAction$1, Divider, Subheader as Subheader$1 } from './styled.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var ListContext =
/*#__PURE__*/
React.createContext({
  variant: "default",
  size: "md"
});
var ListComponent = forwardRef(function (_a, ref) {
  var _b = _a,
      children = _b.children,
      _b$variant = _b.variant,
      variant = _b$variant === void 0 ? "default" : _b$variant,
      _b$size = _b.size,
      size = _b$size === void 0 ? "md" : _b$size,
      props = __objRest(_b, ["children", "variant", "size"]);

  return (
    /* @__PURE__ */
    React.createElement(ListContext.Provider, {
      value: {
        variant: variant,
        size: size
      }
    },
    /* @__PURE__ */
    React.createElement(List$1, __spreadValues({
      as: "nav",
      role: "menu",
      ref: ref
    }, props), children))
  );
});
ListComponent.displayName = "ListComponent";
var ItemIcon = maestroComponent("List.ItemIcon", ItemIcon$1);
var Item = forwardRef(function (props, ref) {
  var context = useContext(ListContext);

  var _a = props,
      children = _a.children,
      onClick = _a.onClick,
      disabled = _a.disabled,
      isDisabled = _a.isDisabled,
      IconComponent = _a.icon,
      addonLeft = _a.addonLeft,
      addonRight = _a.addonRight,
      rest = __objRest(_a, ["children", "onClick", "disabled", "isDisabled", "icon", "addonLeft", "addonRight"]);

  var handleClick = function handleClick(event) {
    if (disabled || isDisabled) {
      return;
    }

    onClick == null ? void 0 : onClick(event);
  };

  return (
    /* @__PURE__ */
    React.createElement(Item$1, __spreadValues(__spreadValues({
      ref: ref,
      role: "menuitem",
      onClick: handleClick,
      disabled: disabled || isDisabled
    }, rest), context), isValidElementType(IconComponent) &&
    /* @__PURE__ */
    React.createElement(ItemIcon, {
      size: context.size
    },
    /* @__PURE__ */
    React.createElement(IconComponent, null)), addonLeft && React.Children.map(addonLeft, function (addon) {
      return (
        /* @__PURE__ */
        React.createElement(Addon, {
          marginRight: "sm"
        }, addon)
      );
    }), children, addonRight && React.Children.map(addonRight, function (addon) {
      return (
        /* @__PURE__ */
        React.createElement(Addon, {
          marginLeft: "auto"
        }, addon)
      );
    }))
  );
});
Item.displayName = "List.Item";

var Subheader = function Subheader(_c) {
  var _d = _c,
      _d$size = _d.size,
      size = _d$size === void 0 ? "sm" : _d$size,
      _d$contrast = _d.contrast,
      contrast = _d$contrast === void 0 ? "low" : _d$contrast,
      props = __objRest(_d, ["size", "contrast"]);

  return (
    /* @__PURE__ */
    React.createElement(Subheader$1, __spreadValues({
      size: size,
      contrast: contrast
    }, props))
  );
};

var ItemSecondaryAction = maestroComponent("List.ItemSecondaryAction", ItemSecondaryAction$1);
var ListComposition = {
  Item: Item,
  ItemIcon: ItemIcon,
  ItemSecondaryAction: ItemSecondaryAction,
  Subheader: Subheader,
  Divider: Divider
};
var List = maestroComponent("List", ListComponent, ListComposition);
export { List, ListContext };